<template>
    <div class="vue-admin">
        <div class="header-banner"><h1>Media & Resources &mdash; Admin</h1></div>
        <div class="page-space">
            <div class="ui secondary segment">
                <error-display v-if="error" :error="error"></error-display>
                <div>
                    <router-link to="/admin/media/create" class="ui small green button" >
                        <i class="plus icon"></i> Create Media/Resources
                    </router-link>
                </div>
                <table class="ui small table segment">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Title</th>
                            <th>Type</th>
                            <th>Date</th>
                            <th>Link</th>
                            <th>Photo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="model in models" :key="model.id">
                            <td><router-link :to="'/admin/media/'+model.id+'/edit'" class="ui mini button">Edit</router-link></td>
                            <td>{{model.title}}</td>
                            <td>{{model.type}}</td>
                            <td>{{ShortDate(model.date)}}</td>
                            <td>{{model.link || 'Post'}}</td>
                            <td><img alt="default" class="img-in-list" :src="model.photo ? model.photo.folder + model.photo.file : '/img/default.jpg?v=1'"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import ErrorDisplay from "../errorDisplay";

    export default {
        components: {ErrorDisplay},
        data: function(){
            return {
                models: [],
                error: null
            };
        },
        mounted: function(){
            document.title = 'Media & Resources — Admin | ' + document.title.split(' | ').pop();
            axios.get('/admin/api/media')
                .then(response=>{if(response.status === 200) this.models = response.data;})
                .catch(error=>{this.error = {message:error.response}});
        },
        methods: {
            ShortDate(date){
                return (new Date(date)).toLocaleDateString();
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/media-resources/index.vue